import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from '../assets/logo.png';
import './ClientLogin.css';

const API = 'https://aayushrealproperties.in/nimaibackend/public/api';

const ClientLogin = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPw, setShowPw] = useState(false);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [clientName, setClientName] = useState('');

    const validate = () => {
        const e = {};
        if (!email.trim()) e.email = 'Email is required.';
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = 'Enter a valid email.';
        if (!password) e.password = 'Password is required.';
        return e;
    };

    const handleSubmit = async (ev) => {
        ev.preventDefault();
        const errs = validate();
        if (Object.keys(errs).length) { setErrors(errs); return; }

        setSubmitting(true);
        setErrors({});

        try {
            const res = await fetch(`${API}/client-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            const text = await res.text();
            const jsonStart = text.search(/\{|\[/);
            const data = JSON.parse(jsonStart !== -1 ? text.substring(jsonStart) : text);

            if (res.ok && data.status) {
                localStorage.setItem('client_token', data.token);
                setClientName(data.data?.first_name || 'Client');
                setLoggedIn(true);
                setTimeout(() => navigate('/client-dashboard/overview', { state: { client: data.data } }), 1200);
            } else {
                setErrors({ submit: data.message || 'Invalid email or password.' });
            }
        } catch {
            setErrors({ submit: 'Something went wrong. Please try again.' });
        } finally {
            setSubmitting(false);
        }
    };

    if (loggedIn) {
        return (
            <div className="client-login-page">
                <div className="client-login-card">
                    <div className="client-login-brand">
                        <img src={logo} alt="Nimai Solutions" />
                        <span>Nimai Solutions</span>
                    </div>
                    <div className="cl-success">
                        <div className="cl-success-icon">✅</div>
                        <h2>Welcome, {clientName}!</h2>
                        <p>You've successfully logged in. Our team will be in touch with your project updates soon.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="client-login-page">
            <div className="client-login-card">
                <div className="client-login-brand">
                    <img src={logo} alt="Nimai Solutions" />
                    <span>Nimai Solutions</span>
                </div>

                <h1 className="client-login-title">Client Login</h1>
                <p className="client-login-sub">Sign in with your onboarding credentials.</p>

                <form onSubmit={handleSubmit} noValidate>
                    <div className="cl-field">
                        <label>Email Address</label>
                        <input
                            type="email"
                            placeholder="john@example.com"
                            value={email}
                            onChange={e => { setEmail(e.target.value); setErrors(p => ({ ...p, email: '' })); }}
                        />
                        {errors.email && <span className="cl-error">{errors.email}</span>}
                    </div>

                    <div className="cl-field">
                        <label>Password</label>
                        <div className="cl-pw-wrap">
                            <input
                                type={showPw ? 'text' : 'password'}
                                placeholder="Your password"
                                value={password}
                                onChange={e => { setPassword(e.target.value); setErrors(p => ({ ...p, password: '' })); }}
                            />
                            <button type="button" className="cl-pw-toggle" onClick={() => setShowPw(p => !p)}>
                                {showPw ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {errors.password && <span className="cl-error">{errors.password}</span>}
                    </div>

                    {errors.submit && (
                        <p className="cl-error" style={{ textAlign: 'center', marginBottom: 8 }}>{errors.submit}</p>
                    )}

                    <button type="submit" className="cl-submit-btn" disabled={submitting}>
                        {submitting ? 'Signing in…' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ClientLogin;
